import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ReserveProvider } from '../providers/reserves';

@Pipe({
    name: 'calendarsReserve'
})

export class calendarReserveDataPipe implements PipeTransform {

    constructor(
        private reserveData: ReserveProvider
    ) { }

    transform(calendarId: string, entityId, eventId, typeReserve): Observable<any> {
        switch (typeReserve) {
            case 'Staff':
                if (eventId) {
                    return this.reserveData.getCalendarEventByStaff(calendarId, entityId, eventId);
                } else {
                    return this.reserveData.getCalendarByStaff(calendarId, entityId);
                }
            case 'CommercialSample':
                if (eventId) {
                    return this.reserveData.getCalendarEventByComercialSample(calendarId, entityId, eventId);
                } else {
                    return this.reserveData.getCalendarByComercialSample(calendarId, entityId);
                }

            case 'Event':
        }


    }
}


// WEBPACK FOOTER //
// ./src/pipes/calendarsReserve.ts